export default __webpack_public_path__ + "assets/images/7dcef4c10d53b5b902c2ede15f39a4ca.svg";